import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Stepper on top of the request flow: Find your agency → Your details → Request sent */
var AccessStepper = function AccessStepper(props) {
  var steps = props.steps,
      activeIndex = props.activeIndex;
  return /*#__PURE__*/_jsx(Box, {
    className: "flex flex-row flex-wrap items-center justify-center gap-x-3 gap-y-2",
    children: steps.map(function (label, index) {
      var done = index < activeIndex;
      var current = index === activeIndex;
      return /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-row items-center gap-x-3",
        children: [index > 0 && /*#__PURE__*/_jsx(Typography, {
          className: "text-gray-300",
          children: "\u2192"
        }), /*#__PURE__*/_jsxs(Box, {
          className: "flex flex-row items-center space-x-2",
          children: [/*#__PURE__*/_jsx(Box, {
            className: clsx('flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold', done || current ? 'bg-[#3B5BFF] text-white' : 'bg-gray-200 text-gray-400'),
            children: done ? /*#__PURE__*/_jsx(Box, {
              component: "svg",
              viewBox: "0 0 24 24",
              className: "h-3.5 w-3.5 fill-white",
              children: /*#__PURE__*/_jsx("path", {
                d: "M9.6 15.6 4.8 10.8l1.4-1.4 3.4 3.4 8-8 1.4 1.4z"
              })
            }) : index + 1
          }), /*#__PURE__*/_jsx(Typography, {
            className: clsx('text-sm', done || current ? 'font-bold text-[#12275B]' : 'font-medium text-gray-400'),
            children: label
          })]
        })]
      }, label);
    })
  });
};

export default AccessStepper;